import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { BulletedList } from '@/components/layouts/Ir/BulletedList'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

export const DisclaimerPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Disclaimer"
        subTitleText="免責事項"
      />
      <Spacer h={{ pc: 63, sp: 50 }} />
      <BulletedList>
        <li>
          <Paragraph>
            当社が開示する業績予想、戦略、方針、目標等のうち、歴史的事実ではないものは将来の見通しに関する記述であり、これらは、当社がその時点で入手している情報及び合理的であると判断される一定の前提に基づく計画、期待、判断を根拠としており、実際の業績等は様々なリスクや不確定要因により大きく異なる可能性があります。
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            本ウェブサイトは投資勧誘を目的としたものではありません。投資に関する決定は利用者ご自身のご判断において行われるようお願いいたします。
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            本ウェブサイトの掲載内容については細心の注意を払っておりますが、掲載された情報の誤りやデータのダウンロードなどによって生じた障害などに関しましては、当社は一切責任を負うものではありませんのでご了承ください。
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            当社は予告なしにウェブサイト上の情報の変更、ウェブサイトの運営を中断または中止させていただくことがありますので、予めご了承ください。
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            当社は、本ホームページからリンクが設定されている他のウェブサイトの情報に関していかなる保証をするものではありません。
          </Paragraph>
        </li>
      </BulletedList>
    </Layout>
  )
}

DisclaimerPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '免責事項', path: '' },
  ]

  return (
    <>
      <Head
        title="免責事項"
        description="トライアルホールディングスの免責事項について掲載しています。"
        ogp={{ url: 'ir/disclaimer/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
